import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { FarmList } from "pages/admin/farms/FarmList";
import { FieldList } from "pages/admin/farms/FieldList";
import { ShapefileList } from "pages/admin/farms/ShapefileList";

export const Farms = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Farms",
      key: "farms",
      component: <FarmList />,
    },
    {
      name: "Fields",
      key: "fields",
      component: <FieldList />,
    },
    {
      name: "Shapefiles",
      key: "shapefiles",
      component: <ShapefileList user={user} />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `farms/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/farms/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
